module.exports = __webpack_public_path__ + "img/2_2-industriale-porto-0.40625ab0.png";